<app-topnav [pageName]="pageName"></app-topnav>


<div class="content" role="main">
  <div class="container">
    <div class="email-details">
      <div class="form-section-header">
        <!-- <app-status-bubble [status]="emailMessage?.status"></app-status-bubble> -->
        <span class="a-status-label {{ emailMessage?.status?.toLocaleLowerCase() }}">
          {{ emailMessage?.status }}
        </span>
        <h2>{{ emailMessage?.subject }}</h2>
      </div>
      <div>
        <label>From: <span>{{ emailMessage?.fromName }} &lt;{{ emailMessage?.fromEmailAddress }}&gt;</span></label>
      </div>
      <div>
        <label>To: <span>{{ emailMessage?.toName }} &lt;{{ emailMessage?.toEmailAddress }}&gt;</span></label>
      </div>
      <div>
        <label>Created: <span>{{ emailMessage?.createdDate | date : "dd/MM/yyyy HH:mm" }}</span></label>
      </div>
      @if (emailMessage?.status == 'Sent') {
        <div>
          <label>Sent: <span>{{ emailMessage?.sentDate | date : "dd/MM/yyyy HH:mm" }}</span></label>
        </div>
      }

      @if (emailMessage?.status === 'Failed') {
        <div>
          <label>Error Message:</label>
          <pre class="error-message-output">
            {{ emailMessage?.errorMessage }}
          </pre>
          <div>
            <label>Times Failed: <span>{{ emailMessage?.timesFailed }}</span></label>
          </div>
        </div>
      }
    </div>

    <hr />
    <div [innerHtml]="emailMessage?.body"></div>

  </div>
</div>

<app-footer></app-footer>